module.exports = __webpack_public_path__ + "img/logo_indosat.e99650af.png";